"use client";

import { createContext, useContext, useState, useCallback, useMemo, type ReactNode } from "react";

type ScrollContextValue = {
    allowScroll: boolean;
    setAllowScroll: ((v: boolean) => void) | null;
};

const ScrollContext = createContext<ScrollContextValue>({
    allowScroll: true,
    setAllowScroll: null,
});

export function useScrollContext() {
    return useContext(ScrollContext);
}

export function ScrollContextProvider({ children }: { children: ReactNode }) {
    const [allowScroll, setAllowScrollState] = useState(true);
    const setAllowScroll = useCallback((v: boolean) => setAllowScrollState(v), []);
    const value = useMemo<ScrollContextValue>(
        () => ({ allowScroll, setAllowScroll }),
        [allowScroll, setAllowScroll]
    );
    return (
        <ScrollContext.Provider value={value}>
            {children}
        </ScrollContext.Provider>
    );
}

